<template>
  <div id="consulting-topic">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex xs6>
          <div class="headline">Consulting Topic</div>
        </v-flex>
        <v-flex text-xs-right xs6>
          <ConsultingTopicDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="states"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>
                  <v-img
                    :aspect-ratio="4 / 4"
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="
                      props.item.pictureCover
                        ? props.item.pictureCover
                        : require('@/assets/NoPicture.png')
                    "
                    class="grey lighten-2"
                    cover
                    width="40"
                  >
                    <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
                      <v-progress-circular
                        color="grey lighten-5"
                        indeterminate
                      ></v-progress-circular>
                    </v-layout>
                  </v-img>
                </td>
                <td>
                  <v-img
                    :aspect-ratio="4 / 4"
                    :lazy-src="require('@/assets/NoPicture.png')"
                    :src="
                      props.item.pictureIcon
                        ? props.item.pictureIcon
                        : require('@/assets/NoPicture.png')
                    "
                    class="grey lighten-2"
                    cover
                    width="40"
                  >
                    <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
                      <v-progress-circular
                        color="grey lighten-5"
                        indeterminate
                      ></v-progress-circular>
                    </v-layout>
                  </v-img>
                </td>
                <td>{{ props.item.name || '-' }}</td>
                <td>
                  <v-icon color="green" v-if="props.item.description">done</v-icon>
                  <div v-else>-</div>
                </td>
                <td>{{ props.item.orders || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import ConsultingTopicDialog from '@/components/admin/ConsultingTopicDialog'

export default {
  name: 'consulting-topic',
  components: {
    ConsultingTopicDialog
  },
  data() {
    return {
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Cover', align: 'left', value: 'pictureCover', width: '40' },
        { text: 'Icon', align: 'left', value: 'pictureIcon', width: '40' },
        { text: 'Name', align: 'left', value: 'name', width: '400' },
        {
          text: 'Desc',
          align: 'left',
          value: 'description',
          width: '10'
        },
        { text: 'Orders', align: 'left', value: 'orders', width: '10' }
      ]
    }
  },
  computed: {
    states() {
      return this.$store.getters['ConsultingTopic/getAll']
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.ConsultingTopic.data.length === 0
      ? store.dispatch('ConsultingTopic/fetch').then(next())
      : next()
  },
  created() {},
  methods: {
    editItem(idx) {
      this.$store.commit('ConsultingTopic/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingTopic/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
